module.exports = __webpack_public_path__ + "img/pulmonology.9bb6bcf2.png";